import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  FaTrash,
  FaPencil,
  FaAngleLeft,
  FaAngleRight,
} from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import BaseUrl from "../../base-api";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";
import { isloading } from "../redux/reducer/LoadingReducer";
import { useDispatch } from "react-redux";
import AxiosInstance from "../Utility/AxiosInstance";
import { getPageNumbers } from "../Utility/pagination";
import { handleAxiosError } from "../Utility/handleAxiosError";
const Links = () => {
    const dispatch = useDispatch();
  const [links, setLinks] = useState([]);
  const [newLink, setNewLink] = useState({ title: "", link: "" });
  const [isEditing, setIsEditing] = useState(false);
  const [currentEditId, setCurrentEditId] = useState(null);
  const [editTitle, setEditTitle] = useState("");
  const [editLocation, setEditLocation] = useState("");
  const [editLink, setEditLink] = useState("");
  const navigate = useNavigate();
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);

  const [viewLinks, setViewLinks] = useState([]); 
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); 
  const [totalItems, setTotalItems] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
 const [totalPages, setTotalPages] = useState(1);
 
  const fetchLinks = async (pageNumber = currentPage) => {
    const backendPage = pageNumber - 1;
    setSearchQuery("");
    setCurrentPage(1);
    const token = sessionStorage.getItem("userToken");
    if (!token) return navigate("/login");
    dispatch(isloading());
    try {
      const resLocation = await AxiosInstance.get(`${BaseUrl}/api/master/linkType`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (resLocation.data.status === 200) {
        const locationTypes = resLocation.data.data.map((item) => item.type);
        setLocations(locationTypes);
      } else {
        toast.error("Failed to fetch locations.");
      }
      const res = await AxiosInstance.post(
        `${BaseUrl}/api/links/getAll`,
        { location: "All" },
        {
          headers: { "Content-Type": "application/json", Authorization: token },
           params: {
            page: backendPage,
            size: itemsPerPage,
          },
        }
      );

      if (res.data.status === 200) {
        setLinks(
          res.data.data.content.map((img) => ({
            id: img.key,
            title: img.title,
            link: img.link,
            location: img.location,
          }))
        );
  setTotalPages(res.data.data.totalPages);
        setTotalItems(res.data.data.totalItems);
        setCurrentPage(pageNumber);
      
        
      } else {
        toast.error("Failed to fetch links.");
      }
    } catch (error) {
      handleAxiosError(error);
    } finally {
     dispatch(isloading());
    }
  };

  useEffect(() => {
    fetchLinks();
  }, []);

  useEffect(() => {
    setViewLinks(links.slice(0, itemsPerPage));
  }, [links]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      fetchLinks(pageNumber);
    }
  };

  const handleNextPage = () => {
      handlePageChange(currentPage + 1);
    };

  const handlePreviousPage = () => {
         handlePageChange(currentPage - 1);
   };

  // Handle Input Changes
  const handleInputChange = (e) => {
    setNewLink({ ...newLink, [e.target.name]: e.target.value });
  };

  // Add New Link
  const handleSave = async () => {
    if (!newLink.title || !newLink.link || !newLink.location) {
      return toast.error("Please fill in all required fields.");
    }
    dispatch(isloading());
    const token = sessionStorage.getItem("userToken");
    try {
      const res = await axios.post(`${BaseUrl}/api/links/create`, newLink, {
        headers: { "Content-Type": "application/json", Authorization: token },
      });

      if (res.data.status === 200) {
        toast.success(res.data.message);
        fetchLinks();
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error("Error adding link.");
    } finally {
      setNewLink({ title: "", link: "", location: "" });
      dispatch(isloading());
    }
  };

  // Open Edit Modal
  const handleEdit = (id) => {
    const link = links.find((l) => l.id === id);
    setEditTitle(link.title);
    setEditLink(link.link);
    setCurrentEditId(id);
    setEditLocation(link.location); // New line
    setIsEditing(true);
  };

  const handleEditSave = async () => {
    if (!editTitle || !editLink || !editLocation)
      return toast.error("All fields are required.");
   dispatch(isloading());
    const token = sessionStorage.getItem("userToken");
    try {
      const res = await axios.post(
        `${BaseUrl}/api/links/update`,
        {
          key: currentEditId,
          title: editTitle,
          link: editLink,
          location: editLocation,
        }, // Updated
        {
          headers: { "Content-Type": "application/json", Authorization: token },
        }
      );

      if (res.data.status === 200) {
        toast.success(res.data.message);
        fetchLinks();
        setIsEditing(false);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error("Error updating link.");
    } finally {
    dispatch(isloading());
    }
  };

  // Delete Link
  const handleDelete = async (id) => {
    const toastId = toast.warn(
      <div
        style={{ textAlign: "center", fontSize: "18px", fontWeight: "bold" }}
      >
        <p>Are you sure you want to delete this link?</p>
        <div className="d-flex justify-content-center">
          <button
            className="btn btn-danger btn-sm mx-2"
            onClick={() => confirmDelete(id, toastId)}
          >
            Yes
          </button>
          <button
            className="btn btn-secondary btn-sm"
            onClick={() => toast.dismiss(toastId)}
          >
            No
          </button>
        </div>
      </div>,
      {
        autoClose: false,
        closeOnClick: false,
        toastClassName: "toast-container",
        closeButton: false,
      }
    );
  };
 const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

  const confirmDelete = async (id, toastId) => {
    toast.dismiss(toastId); // Close the confirmation toast
    const loadingToast = toast.loading("Deleting link...");
    dispatch(isloading());
    try {
      const token = sessionStorage.getItem("userToken");
      const res = await axios.post(
        `${BaseUrl}/api/links/delete`,
        { key: id },
        {
          headers: { "Content-Type": "application/json", Authorization: token },
        }
      );

      toast.dismiss(loadingToast);
      if (res.data.status === 200) {
        toast.success(res.data.message);
        fetchLinks();
        setLinks((prevLinks) => prevLinks.filter((link) => link.id !== id)); // Instantly update UI
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error("Error deleting link.");
    } finally {
     dispatch(isloading());
    }
  };

  const handleLocationChange = (e) => {
    setNewLink((prevState) => ({
      ...prevState,
      location: e.target.value,
    }));
  };


  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    
    // Filter links based on search query (title, location, or link)
    const filteredLinks = links.filter(
      (link) =>
        link.title.toLowerCase().includes(query) ||
        link.location.toLowerCase().includes(query) ||
        link.link.toLowerCase().includes(query)
    );
  
    setTotalItems(filteredLinks.length);
    setCurrentPage(1); // Reset to first page
    setViewLinks(filteredLinks.slice(0, itemsPerPage));
  };
  return (
  
        <div className="home-dashboard">
          <div className="ticket-tab">
            <h3>Upload Link</h3>
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">
                  Location
                  <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <select
                  className="form-select"
                  value={newLink.location}
                  onChange={handleLocationChange}
                >
                  <option value="">Select Location</option>
                  {locations.map((loc, index) => (
                    <option key={index} value={loc}>
                      {loc}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label">
                  Title<span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="title"
                  value={newLink.title}
                  onChange={handleInputChange}
                  placeholder="Enter Title of link"
                />
              </div>

              <div className="col-md-6 mt-4">
                <label className="form-label">
                  Link<span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="link"
                  value={newLink.link}
                  onChange={handleInputChange}
                  placeholder="Enter Hyperlink"
                />
              </div>

              <div className="col-md-2 mt-2">
                <button className="btn btn-success mt-5" onClick={handleSave}>
                  Save
                </button>
              </div>
            </div>
          </div>

          {/* <hr style={{  height: "2px", backgroundColor: "green", margin:"4% 0"}} /> */}
          <div className="ticket-tab">
            <div className="row mb-4">
              <div className="col-6">
                
            <h3>Manage Links</h3>
              </div>

    <div className="col-6">
      <input
        type="text"
        className="form-control"
        placeholder="Search by title, location, or link..."
        value={searchQuery}
        onChange={handleSearch}
      />
   
  </div>
  </div>
            <table className="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th style={{ width: "25%" }}>Location</th>
                  <th style={{ width: "30%" }}>Title</th>
                  <th style={{ width: "30%" }}>Link</th>
                  <th style={{ width: "15%" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {viewLinks.length > 0 ? (
                  viewLinks.map((link) => (
                    <tr key={link.id}>
                      <td>{link.location}</td>
                      <td>{link.title}</td>
                      <td>
                        <a
                          href={link.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {link.link}
                        </a>
                      </td>
                      <td>
                        <FaPencil
                          className="me-2"
                          style={{ cursor: "pointer", color: "orange" }}
                          onClick={() => handleEdit(link.id)}
                          title="Edit"
                        />
                        <FaTrash
                          style={{ cursor: "pointer", color: "red" }}
                          onClick={() => handleDelete(link.id)}
                          title="Delete"
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center">
                      No Links Found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
             <div className="row mt-4" style={{ "--bs-gutter-x": "0rem" }}>
                                    <div className="col-5">
                                      {totalItems > 0
                                        ? `Showing ${startIndex + 1}-${endIndex} of ${totalItems}`
                                        : "No items to display"}
                                    </div>
                                    <div className="col-7 d-flex justify-content-end">
                                      <div className="d-flex align-items-center">
                                        <button
                                          style={{
                                            width: "35px",
                                            height: "35px",
                                            borderRadius: "50%",
                                          }}
                                          className="btn btn-success d-flex align-items-center justify-content-center"
                                          onClick={handlePreviousPage}
                                          disabled={currentPage === 1}
                                        >
                                          <FaAngleLeft />
                                        </button>
                        
                                        <div className="mx-3 d-flex">
                                          {getPageNumbers(currentPage, totalPages).map(
                                            (pageNum, index) =>
                                              pageNum === "..." ? (
                                                <span key={`ellipsis-${index}`} className="mx-1">
                                                  ...
                                                </span>
                                              ) : (
                                                <button
                                                  key={pageNum}
                                                  className={`btn mx-1 ${
                                                    currentPage === pageNum
                                                      ? "active btn-primary"
                                                      : "btn-light"
                                                  }`}
                                                  onClick={() => handlePageChange(pageNum)}
                                                >
                                                  {pageNum}
                                                </button>
                                              )
                                          )}
                                        </div>
                        
                                        <button
                                          style={{
                                            width: "35px",
                                            height: "35px",
                                            borderRadius: "50%",
                                          }}
                                          className="btn btn-success d-flex align-items-center justify-content-center"
                                          onClick={handleNextPage}
                                          disabled={currentPage >= totalPages}
                                        >
                                          <FaAngleRight />
                                        </button>
                                      </div>
                                    </div>
                                  </div>

          </div>

          <Modal isOpen={isEditing} toggle={() => setIsEditing(false)} centered>
            <ModalHeader toggle={() => setIsEditing(false)}>
              Edit Link
            </ModalHeader>
            <ModalBody>
              <label className="form-label">Location</label>
              <select
                className="form-select mb-3"
                value={editLocation}
                onChange={(e) => setEditLocation(e.target.value)}
              >
                <option value="">Select Location</option>
                {locations.map((loc, index) => (
                  <option key={index} value={loc}>
                    {loc}
                  </option>
                ))}
              </select>
              <input
                className="form-control mb-3"
                value={editTitle}
                onChange={(e) => setEditTitle(e.target.value)}
                placeholder="Title"
              />
              <input
                className="form-control"
                value={editLink}
                onChange={(e) => setEditLink(e.target.value)}
                placeholder="Link"
              />
            </ModalBody>
            <ModalFooter className="flex-nowrap">
              <Button color="success" onClick={handleEditSave}>
                Save Changes
              </Button>
              <Button color="secondary" onClick={() => setIsEditing(false)}>
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
        </div>
  
  );
};

export default Links;
